import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/close.svg'
import _imports_1 from '@/assets/images/invite.gif'


const _withScopeId = n => (_pushScopeId("data-v-66bf59ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + '#shape'
const _hoisted_2 = {
  key: 0,
  id: "alertBackground"
}
const _hoisted_3 = { id: "alertWrapper" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = {
  class: "col-11 col-md-8 col-lg-6 col-xl-5 col-xxl-4",
  style: {"padding":"0"}
}
const _hoisted_7 = { id: "alert" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { href: _hoisted_1 }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  id: "alertImage"
}, null, -1))
const _hoisted_11 = { id: "alertTitle" }
const _hoisted_12 = { id: "alertButtonWrapper" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  id: "linkCopied"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isHidden)
    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("footer", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(), _createElementBlock("svg", {
                    id: "closeButton",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeAlert && _ctx.closeAlert(...args)))
                  }, _hoisted_9)),
                  _hoisted_10,
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t('shareItem')), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("a", {
                      class: "alertButton",
                      href: _ctx.facebookLink,
                      target: "_blank",
                      rel: "noopener",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickedSocialShare && _ctx.clickedSocialShare(...args))),
                      id: "openButton"
                    }, _toDisplayString(_ctx.t('Facebook')), 9, _hoisted_13),
                    _createElementVNode("a", {
                      class: "alertButton",
                      href: _ctx.twitterLink,
                      target: "_blank",
                      rel: "noopener",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickedSocialShare && _ctx.clickedSocialShare(...args))),
                      id: "openButton"
                    }, _toDisplayString(_ctx.t('Twitter')), 9, _hoisted_14),
                    _createElementVNode("a", {
                      class: "alertButton",
                      href: _ctx.emailLink,
                      target: "_blank",
                      rel: "noopener",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickedSocialShare && _ctx.clickedSocialShare(...args))),
                      id: "openButton"
                    }, _toDisplayString(_ctx.t('Email')), 9, _hoisted_15),
                    _createElementVNode("a", {
                      class: "alertButton",
                      id: "openButton",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)))
                    }, [
                      (!_ctx.linkCopied)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.t('copyLink')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.linkCopied)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.t('copiedLink')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}